import merge from 'lodash.merge';

/**
 * @warning - this method mutates target, so it's recommended to use `mergeDeepSafe` in most places
 */
const mergeDeep = <TTarget, TSource>(
  target: TTarget,
  source: TSource,
): TTarget & TSource => merge(target, source);

export default mergeDeep;
